module.exports = __webpack_public_path__ + "img/personal_time4.9588baeb.png";